export const bundleOptions =
    {
        ADVICE: [
            {
                value: 2,
                price: 56,
                discount: 20,
                name: "TWO_ADVICE_CREDITS"
            },
            {
                value: 4,
                price: 111,
                discount: 21,
                name: "FOUR_ADVICE_CREDITS"
            },
            {
                value: 6,
                price: 164,
                discount: 22,
                name: "SIX_ADVICE_CREDITS"
            },
            {
                value: 12,
                price: 307,
                discount: 27,
                name: "TWELVE_ADVICE_CREDITS"
            }
        ],
        DEFAULT: [
            {
                value: 2,
                price: 95,
                discount: 13.6,
                name: "TWO_CREDITS"
            },
            {
                value: 4,
                price: 180,
                discount: 18.2,
                name: "FOUR_CREDITS"
            },
            {
                value: 6,
                price: 255,
                discount: 22.7,
                name: "SIX_CREDITS"
            },
            {
                value: 12,
                price: 480,
                discount: 27.3,
                name: "TWELVE_CREDITS"
            },
        ]
    };
